export const getHostName = host => {
  const QA_ENV = 'qa';
  const UAT_ENV = 'uat';
  const LOCALHOST_ENV = 'localhost';
  if (host) {
    if (host.includes(QA_ENV)) {
      return `${QA_ENV}_`;
    } else if (host.includes(UAT_ENV)) {
      return `${UAT_ENV}_`;
    } else if (host.includes(LOCALHOST_ENV)) {
      return `${QA_ENV}_`;
    } else {
      return '';
    }
  }
  return '';
};